export const BOT_USERNAME = import.meta.env.VITE_TELEGRAM_BOT_USERNAME || 'tabletop_trail_bot';

export const BOT_URL = `https://t.me/${BOT_USERNAME}`;
